import { useTranslations } from '@/lib/next-shim'

export function Description({ description }: { description: string }) {
  const t = useTranslations()
  return (
    <section aria-labelledby="description-heading" className="bg-white rounded-lg shadow-sm overflow-hidden">
      <div className="px-4 py-5 border-b border-gray-200 sm:px-6">
        <h2 id="description-heading" className="text-xl font-medium text-gray-900">
          {t('page.MeetingLink.descriptionSection.title')}
        </h2>
      </div>
      <div className="px-4 py-5 sm:px-6">
        <p className="text-base text-gray-700 whitespace-pre-line">{description}</p>
      </div>
    </section>
  )
}
